import { createSelector } from '@reduxjs/toolkit';
import { CircleModel } from 'api/dto/Circle.dto';
import { AdminState } from 'reduxStore/appStore';
import { selectCompanyCircleId } from 'reduxStore/project/projectSelector';
import { WB_CIRCLE_NAME } from 'shared/constants';

import { CirclesState } from './initialState';

export const selectCirclesDomain = (state: AdminState) => state.circles as CirclesState.Domain;

export const selectCirclesResource = createSelector(selectCirclesDomain, (domain) => domain.list);

export const selectCircles = createSelector(
  selectCirclesDomain,
  (domain) => domain.list.data ?? ([] as CircleModel[]),
);

export const selectCurrentCircle = createSelector(
  selectCompanyCircleId,
  selectCircles,
  (currCircleId, circles) => circles.find((circle) => currCircleId === circle.id),
);

export const selectIsInWorkBuzzCircle = createSelector(selectCircles, (circles) => {
  return circles.some((circle) => circle.name === WB_CIRCLE_NAME);
});

export const selectHasRegularProjects = createSelector(
  selectCircles,
  selectCurrentCircle,
  (circles, currentCircle) =>
    currentCircle?.hasRegularProjects || circles.some((circle) => circle.hasRegularProjects),
);
